import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { IntegrationsRoutes } from 'pages/settings/pages/integrations/route/type'
import {
  IntegrationDescription,
  IntegrationPage,
  IntegrationSettings,
} from 'pages/settings/pages/integrations/pages'
import { IntegrationDetailsLayout } from 'pages/settings/pages/integrations/layout/IntegrationDetailsLayout'
import { WebhookLayout } from 'pages/settings/pages/integrations/layout/WebhookLayout'
import { IntegrationDetailsIndexRedirect } from 'pages/settings/pages/integrations/route/IntegrationDetailsIndexRedirect'
import { IntegrationsAccessLayout } from 'pages/settings/pages/integrations/layout/IntegrationsAccessLayout'
import { IntegrationWebhooks } from 'pages/settings/pages/integrations/pages/Webhooks/IntegrationWebhooks'
import { WebhookPage } from 'pages/settings/pages/integrations/pages/Webhooks/ui/WebhookPage'
import { HistoryPage } from 'pages/settings/pages/integrations/pages/Webhooks/ui/HistoryPage/HistoryPage'

export const IntegrationsRouter = observer(() => {
  return (
    <Routes>
      <Route element={<IntegrationsAccessLayout />}>
        <Route path={'/'} element={<IntegrationPage />} />
        <Route path={IntegrationsRoutes.webhooks} element={<WebhookLayout />}>
          <Route index element={<IntegrationWebhooks />} />
          <Route path={IntegrationsRoutes.create} element={<WebhookPage />} />
          <Route path={`${IntegrationsRoutes.edit}/:id`} element={<WebhookPage />} />
          <Route path={`${IntegrationsRoutes.history}/:id`} element={<HistoryPage />} />
        </Route>
        <Route path=':id' element={<IntegrationDetailsLayout />}>
          <Route path={IntegrationsRoutes.settings} element={<IntegrationSettings />} />
          <Route path={IntegrationsRoutes.description} element={<IntegrationDescription />} />
          <Route index element={<IntegrationDetailsIndexRedirect />} />
        </Route>
        <Route path={'*'} element={<Navigate to={'/'} />} />
      </Route>
    </Routes>
  )
})
